import React from 'react';
import cn from 'classnames';
import style from './checkDetail.module.scss';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { useOutletContext } from 'react-router-dom';
import { getObjectValue } from '@utility/utills';
import PropTypes from 'prop-types';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';


const MODEBUTTONS = () => {
  return {
    DEFAULT: [
      {
        type: 'inProgress',
        label: FLABEL().ACTION_PROGRESS,
      },
      {
        type: 'complete',
        label: FLABEL().ACTION_DONE,
      },
      { type: 'pickedUp', label: FLABEL().ACTION_PICKED },
      {
        type: 'canceled',
        label: FLABEL().ACTION_CANCEL_ORDER,
      },
      { type: 'preAuth', label: FLABEL().ACTION_PREAUTH },
      {
        type: 'notifyGuest',
        label: FLABEL().ACTION_NOTIFY_GUEST,
      },
      { type: 'print', label: FLABEL().ACTION_PRINT },
      { type: 'receipt', label: FLABEL().ACTION_RECEIPT },
      { type: 'syncCheck', label: FLABEL().ACTION_SYNC_CHECK },
      { type: 'repostPayment', label: FLABEL().ACTION_REPOST },
    ],
    ON_PREMISE: [
      {
        type: 'canceled',
        label: FLABEL().ACTION_CANCEL_ORDER,
      },
      { type: 'preAuth', label: FLABEL().ACTION_PREAUTH },
      { type: 'print', label: FLABEL().ACTION_PRINT },
      { type: 'receipt', label: FLABEL().ACTION_RECEIPT },
      { type: 'syncCheck', label: FLABEL().ACTION_SYNC_CHECK },
      { type: 'repostPayment', label: FLABEL().ACTION_REPOST },
    ],
    OFF_PREMISE: [
      {
        type: 'inProgress',
        label: FLABEL().ACTION_PROGRESS,
      },
      {
        type: 'complete',
        label: FLABEL().ACTION_DONE,
      },
      { type: 'pickedUp', label: FLABEL().ACTION_PICKED },
      {
        type: 'canceled',
        label: FLABEL().ACTION_CANCEL_ORDER,
      },
      {
        type: 'notifyGuest',
        label: FLABEL().ACTION_NOTIFY_GUEST,
      },
      { type: 'print', label: FLABEL().ACTION_PRINT },
      { type: 'receipt', label: FLABEL().ACTION_RECEIPT },
      { type: 'syncCheck', label: FLABEL().ACTION_SYNC_CHECK },
      { type: 'repostPayment', label: FLABEL().ACTION_REPOST },
    ],
    OFF_PREMISE_VENUE: [
      {
        type: 'inProgress',
        label: FLABEL().ACTION_PROGRESS,
      },
      {
        type: 'complete',
        label: FLABEL().ACTION_DONE,
      },
      { type: 'pickedUp', label: FLABEL().ACTION_PICKED },
      {
        type: 'canceled',
        label: FLABEL().ACTION_CANCEL_ORDER,
      },
      {
        type: 'notifyGuest',
        label: FLABEL().ACTION_NOTIFY_GUEST,
      },
      { type: 'print', label: FLABEL().ACTION_PRINT },
      { type: 'receipt', label: FLABEL().ACTION_RECEIPT },
      { type: 'syncCheck', label: FLABEL().ACTION_SYNC_CHECK },
      { type: 'repostPayment', label: FLABEL().ACTION_REPOST },
    ],
    TABLE_DELIVERY: [
      {
        type: 'inProgress',
        label: FLABEL().ACTION_PROGRESS,
      },
      {
        type: 'complete',
        label: FLABEL().ACTION_DONE,
      },
      { type: 'pickedUp', label: FLABEL().ACTION_PICKED },
      {
        type: 'canceled',
        label: FLABEL().ACTION_CANCEL_ORDER,
      },
      {
        type: 'notifyGuest',
        label: FLABEL().ACTION_NOTIFY_GUEST,
      },
      { type: 'syncCheck', label: FLABEL().ACTION_SYNC_CHECK },
      { type: 'repostPayment', label: FLABEL().ACTION_REPOST },
    ],
    FUTURE_ORDERS: [
      {
        type: 'inProgress',
        label: FLABEL().ACTION_PROGRESS,
      },
      {
        type: 'complete',
        label: FLABEL().ACTION_DONE,
      },
      { type: 'pickedUp', label: FLABEL().ACTION_PICKED },
      {
        type: 'canceled',
        label: FLABEL().ACTION_CANCEL_ORDER,
      },
      { type: 'preAuth', label: FLABEL().ACTION_PREAUTH },
      {
        type: 'notifyGuest',
        label: FLABEL().ACTION_NOTIFY_GUEST,
      },
      { type: 'print', label: FLABEL().ACTION_PRINT },
      { type: 'receipt', label: FLABEL().ACTION_RECEIPT },
      { type: 'syncCheck', label: FLABEL().ACTION_SYNC_CHECK },
    ],
  };
};
const getDynamicStatusButtons = item => {
  let { orderStatusId, unpaidAmount, tickets, sourceType } = item || {};
  if (sourceType === 0) {
    orderStatusId =
      orderStatusId === 0
        ? unpaidAmount > 0 && tickets && tickets.length > 0
          ? 0
          : 1
        : orderStatusId;
  }
  const [order0] = item?.orders || [];
  const { pickUpStatus } = order0 || {};

  let statusId = orderStatusId;

  if (statusId === 5 && pickUpStatus === 5) {
    statusId = 6;
  }
  let newButtons = [];
  switch (statusId) {
    case 0: // Pending
      newButtons.push({
        type: 'inProgress',
        label: FLABEL().ACTION_PROGRESS,
      });
      newButtons.push({
        type: 'complete',
        label: FLABEL().ACTION_DONE,
      });
      newButtons.push({
        type: 'pickedUp',
        label: FLABEL().ACTION_PICKED ,
      });
      break;

    case 1: // In-Progress
      newButtons.push({
        type: 'pending',
        label: FLABEL().ACTION_BACK_TO_PENDING,
      });
      newButtons.push({
        type: 'complete',
        label: FLABEL().ACTION_DONE,
      });
      newButtons.push({
        type: 'pickedUp',
        label: FLABEL().ACTION_PICKED,
      });
      break;

    case 5: // Done
      newButtons.push({
        type: 'pending',
        label: FLABEL().ACTION_BACK_TO_PENDING,
      });
      newButtons.push({
        type: 'inProgress',
        label: FLABEL().ACTION_BACK_TO_INPROGRESS,
      });
      newButtons.push({
        type: 'pickedUp',
        label: FLABEL().ACTION_PICKED,
      });
      break;

    case 6: // Picked Up (or if pickedUp status exists)
      newButtons.push({
        type: 'pending',
        label: FLABEL().ACTION_BACK_TO_PENDING,
      });
      newButtons.push({
        type: 'inProgress',
        label: FLABEL().ACTION_BACK_TO_INPROGRESS,
      });
      newButtons.push({
        type: 'notPickedUp',
        label: FLABEL().ACTION_MARK_NOT_PICKEDUP,
      });
      break;

    default:
      newButtons.push({
        type: 'inProgress',
        label: FLABEL().ACTION_PROGRESS,
      });
      newButtons.push({
        type: 'complete',
        label: FLABEL().ACTION_DONE,
      });
      newButtons.push({
        type: 'pickedUp',
        label: FLABEL().ACTION_PICKED,
      });
      break;
  }

  return newButtons;
};

const ActionButton = props => {
  const { handleExpandedRightSection } = useOutletContext();
  const { mode, setIsFlip, item, updateOrderStatus, isExpanded } = props;
  const staticButtons = MODEBUTTONS()[mode] || MODEBUTTONS()['ON_PREMISE'];
  const statusButtons = getDynamicStatusButtons(item);

  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('auth'), false)
  );
  const buttons = [
    ...statusButtons,
    ...staticButtons.filter(
      btn => !['inProgress', 'complete', 'pickedUp'].includes(btn.type)
    ),
  ];

  const handleValidations = (type, item) => {
    const [order0] = item?.orders || [];
    const { pickUpStatus } = order0 || {};
    const isEnabled =
      item.orderStatusId === 0 ||
      item.orderStatusId === 1 ||
      item.orderStatusId === 9 ||
      (item.orderStatusId === 5 && pickUpStatus !== 5);
    const checkRepost =
      item?.tickets?.length > 0 && !item?.isOneDineCheck && item?.open;
    switch (type) {
      case 'inProgress':
        return isEnabled;
      case 'complete':
        return isEnabled;
      case 'pending':
        return isEnabled;
      case 'pickedUp':
        return item.orderStatusId === 5 && pickUpStatus === 0;
      case 'canceled':
        return item.orderStatusId !== 5 && item.orderStatusId !== 8;
      case 'repostPayment':
        return checkRepost;
      default:
        return true;
    }
  };

  const handleActions = (item, type) => {
    switch (type) {
      case 'inProgress':
      case 'complete':
      case 'pickedUp':
      case 'pending':
      case 'backToDone':
      case 'canceled':
      case 'notPickedUp':
      case 'syncCheck':
        updateOrderStatus(item, type);
        break;
      case 'print':
      case 'notifyGuest':
      case 'receipt':
      case 'repostPayment':
        handleExpandedRightSection(type);
        break;
      default:
        break;
    }
  };

  const renderActionsButtons = btn => {
    const enabled = handleValidations(btn.type, item || {});
    const visible =
      btn.type === 'repostPayment' ? !storeInfo?.nonIntegratedPos : true;

    return (
      visible && (
        <div
          className={cn(
            !enabled && style.actionBtnContainerDisabled,
            style.actionBtnContainer
          )}
          onClick={() => enabled && handleActions(item, btn.type)}
        >
          <div
            className={cn(
              'w-100 h-100 px-0 fs_18 fw-500 d-flex align-items-center justify-content-center text-center',
              style.actionLabel
            )}
          >
            {btn.label}
          </div>
        </div>
      )
    );
  };
  const renderActionButtonsInExpandedView = btn => {
    const enabled = handleValidations(btn.type, item || {});
    const visible =
      btn.type === 'repostPayment' ? !storeInfo?.nonIntegratedPos : true;

    return (
      visible && (
        <div
          className={cn(
            !enabled && style.actionBtnContainerDisabled,
            style.actionBtnContainerExpanded
          )}
          onClick={() => enabled && handleActions(item, btn.type)}
        >
          <div
            className={cn(
              'w-100 h-100 px-0 fw-500 text-center d-flex align-items-center justify-content-center'
            )}
          >
            {btn.label}
          </div>
        </div>
      )
    );
  };
  return (
    <div
      className={cn(
        'col-12 px-0',
        isExpanded ? `pt-3 position-absolute ${style.btm0}` : 'py-3'
      )}
    >
      {!isExpanded && (
        <div className="w-100 row mx-0">
          <div className={cn('col-6 px-0', style.actionBtnLabel)}>
            {FLABEL().NOTIFICATION_ACTIONS}
          </div>
          <div
            className={cn(
              'col-6 px-0 d-flex align-items-center justify-content-end'
            )}
          >
            <span
              className={cn(
                'd-flex justify-content-center align-items-center',
                style.actionBtnCrossContainer
              )}
              onClick={() => setIsFlip(false)}
            >
              <Cross fill="var(--primary-icon-color)" />
            </span>
          </div>
        </div>
      )}
      <div
        className={cn(
          isExpanded
            ? buttons.length > 10
              ? style.actionBtnGridExpandFour
              : style.actionBtnGridExpandThree
            : `pt-4 ${style.actionBtnGrid}`
        )}
      >
        {buttons?.map((btn, index) => (
          <div>
            {isExpanded
              ? renderActionButtonsInExpandedView(btn)
              : renderActionsButtons(btn)}
          </div>
        ))}
      </div>
    </div>
  );
};
ActionButton.propTypes = {
  mode: PropTypes.string,
  setIsFlip: PropTypes.func,
  item: PropTypes.object,
  updateOrderStatus: PropTypes.func,
  isExpanded: PropTypes.bool,
};

export default ActionButton;
